var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_delete_small_svg__painted",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.72 4.28a.747.747 0 0 0-1.056 0L9 7.941 5.336 4.28a.747.747 0 1 0-1.057 1.057L7.942 9 4.28 12.664a.747.747 0 1 0 1.057 1.057L9 10.057l3.664 3.664a.747.747 0 1 0 1.057-1.057L10.057 9l3.664-3.664a.747.747 0 0 0 0-1.057Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bb45ea185e7e8e437ded4df5faa56f90.svg";
export { ForwardRef as ReactComponent };